'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class2, _class3, _temp, _dec3, _class4, _dec4, _class5, _class6, _temp2, _dec5, _class7, _class8, _temp3, _dec6, _class9, _dec7, _class10, _class11, _temp4, _dec8, _class12, _dec9, _class13, _dec10, _class14, _dec11, _dec12, _class15, _class16, _temp5;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactChartjs = require('react-chartjs');

var _reactSlidedown = require('react-slidedown');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _TspLanding = require('./TspLanding.css');

var _TspLanding2 = _interopRequireDefault(_TspLanding);

var _tspSocialShare = require('../../../static/images/tsp-social-share.jpg');

var _tspSocialShare2 = _interopRequireDefault(_tspSocialShare);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TspStarsBar = (_dec = (0, _reactCssModules2.default)(_TspLanding2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(TspStarsBar, _Component);

  function TspStarsBar() {
    (0, _classCallCheck3.default)(this, TspStarsBar);
    return (0, _possibleConstructorReturn3.default)(this, (TspStarsBar.__proto__ || (0, _getPrototypeOf2.default)(TspStarsBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(TspStarsBar, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { styleName: 'tsp-lede-stars' });
    }
  }]);
  return TspStarsBar;
}(_react.Component)) || _class);
var TspLede = (_dec2 = (0, _reactCssModules2.default)(_TspLanding2.default, { allowMultiple: true }), _dec2(_class2 = (_temp = _class3 = function (_Component2) {
  (0, _inherits3.default)(TspLede, _Component2);

  function TspLede(props) {
    (0, _classCallCheck3.default)(this, TspLede);
    return (0, _possibleConstructorReturn3.default)(this, (TspLede.__proto__ || (0, _getPrototypeOf2.default)(TspLede)).call(this, props));
  }

  (0, _createClass3.default)(TspLede, [{
    key: 'render',
    value: function render() {
      // const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'lede-wrap-outer' },
        _react2.default.createElement(
          'div',
          { styleName: 'lede-wrap' },
          _react2.default.createElement('div', { styleName: 'lede-xs-graphic visible-xs' }),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h1',
              { styleName: 'lede-h1' },
              'The Thrift Savings Plan has',
              _react2.default.createElement(
                'span',
                { styleName: 'lede-h1-strong hidden-xs' },
                this.props.roundToBillions(_config2.default.tspHoldingStats.ff_all_asset)
              ),
              _react2.default.createElement(
                'span',
                { styleName: 'lede-h1-strong visible-xs' },
                this.props.roundToBillions(_config2.default.tspHoldingStats.ff_all_asset, false, true)
              ),
              'in fossil fuel stocks'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'lede-p-wrap' },
              _react2.default.createElement(
                'p',
                null,
                'The Federal Thrift Savings Plan (TSP) manages over $725 billion in retirement savings for 6 million federal employees. It\'s putting those savings into coal, oil, and gas companies that are driving the climate crisis.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If the TSP continues to ignore climate change, plan participants could face financial losses from stranded assets and other climate-related financial risks.'
              )
            )
          )
        ),
        _react2.default.createElement(TspStarsBar, null)
      );
    }
  }]);
  return TspLede;
}(_react.Component), _class3.propTypes = {
  roundToBillions: _react.PropTypes.func.isRequired
}, _temp)) || _class2);
var TspBanner = (_dec3 = (0, _reactCssModules2.default)(_TspLanding2.default, { allowMultiple: true }), _dec3(_class4 = function (_Component3) {
  (0, _inherits3.default)(TspBanner, _Component3);

  function TspBanner() {
    (0, _classCallCheck3.default)(this, TspBanner);
    return (0, _possibleConstructorReturn3.default)(this, (TspBanner.__proto__ || (0, _getPrototypeOf2.default)(TspBanner)).apply(this, arguments));
  }

  (0, _createClass3.default)(TspBanner, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(TspStarsBar, null),
        _react2.default.createElement(
          'div',
          { styleName: 'banner-wrap' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'p',
              { styleName: 'banner-copy' },
              'Extreme weather like wildfires, floods, droughts, and storms have tripled in the last 30 years. Economists say climate change could cause the ',
              _react2.default.createElement(
                'span',
                { styleName: 'banner-red' },
                'next great financial crisis.'
              )
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'banner-copy' },
              'We can\'t meet the goals of the Paris Climate Agreement and limit global warming to 1.5\u02DAC while expanding coal, oil, and gas. We need climate justice now, and we need the Thrift Savings Plan to do more.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'banner-cta' },
              _react2.default.createElement(
                'h3',
                null,
                'How retirement plans fuel the climate crisis'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: 'https://investyourvalues.org/the-issues/fossil-fuels',
                    title: 'Asset managers are investing in the climate crisis'
                  },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'banner-cta-btn' },
                    'Learn More'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(TspStarsBar, null)
      );
    }
  }]);
  return TspBanner;
}(_react.Component)) || _class4);
var TspPieChart = (_dec4 = (0, _reactCssModules2.default)(_TspLanding2.default, { allowMultiple: true }), _dec4(_class5 = (_temp2 = _class6 = function (_Component4) {
  (0, _inherits3.default)(TspPieChart, _Component4);

  function TspPieChart(props) {
    (0, _classCallCheck3.default)(this, TspPieChart);
    return (0, _possibleConstructorReturn3.default)(this, (TspPieChart.__proto__ || (0, _getPrototypeOf2.default)(TspPieChart)).call(this, props));
  }

  (0, _createClass3.default)(TspPieChart, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      return _react2.default.createElement(
        _components.ContainerDivs,
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'tsp-pie-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'tsp-pie-content' },
            _react2.default.createElement(
              'h2',
              { styleName: 'tsp-pie-h2' },
              _format2.default.perc(_config2.default.tspHoldingStats.oil_majors[1]),
              ' of TSP fossil fuel investments are in ',
              _react2.default.createElement(
                'strong',
                { styleName: 'tsp-pie-h2-strong' },
                '10 oil & gas majors'
              )
            ),
            _react2.default.createElement(
              'table',
              { styleName: 'oil-majors-table' },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('th', null),
                  _react2.default.createElement(
                    'th',
                    null,
                    '$USD invested'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '% of fossil fuel investments'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _config2.default.tspHoldingStats.oil_majors[2].map(function (e, i) {
                  var p = _format2.default.perc(e[1] / _config2.default.tspHoldingStats.ff_all_asset);
                  var a = _this5.props.roundToBillions(e[1], false, true);
                  return _react2.default.createElement(
                    'tr',
                    { key: 'li-oil-major-' + i },
                    _react2.default.createElement(
                      'td',
                      null,
                      e[0]
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      a
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      p
                    )
                  );
                }),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      'Total'
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      this.props.roundToBillions(_config2.default.tspHoldingStats.oil_majors[0], false, true)
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      _format2.default.perc(_config2.default.tspHoldingStats.oil_majors[1])
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'doughnut-wrap' },
            _react2.default.createElement(_reactChartjs.Doughnut, {
              data: [{
                value: _config2.default.tspHoldingStats.oil_majors[1],
                label: 'Top 10 Oil Majors: ' + _format2.default.perc(_config2.default.tspHoldingStats.oil_majors[1]),
                color: '#821400'
              }, {
                value: _config2.default.tspHoldingStats.og[1] - _config2.default.tspHoldingStats.oil_majors[1],
                label: 'Other Oil & Gas: ' + _format2.default.perc(_config2.default.tspHoldingStats.og[1] - _config2.default.tspHoldingStats.oil_majors[1]),
                color: '#D2371B'
              }, {
                value: _config2.default.tspHoldingStats.ut[1],
                label: 'Utilities: ' + _format2.default.perc(_config2.default.tspHoldingStats.ut[1]),
                color: '#A95C0B'
              }, {
                value: _config2.default.tspHoldingStats.other[1],
                label: 'Other: ' + _format2.default.perc(_config2.default.tspHoldingStats.other[1]),
                color: '#333'
              }],
              options: {
                animation: false,
                segmentStrokeWidth: 0,
                percentageInnerCutout: 0,
                // animationEasing: 'easeOutQuad',
                // String - Template string for single tooltips
                // tooltipTemplate: "<%if (label){%><%=label %>: <%}%><%= value + ' %' %>",
                tooltipTemplate: '<%=label %>',
                // String - Template string for multiple tooltips
                multiTooltipTemplate: "<%= value + ' %' %>",
                onAnimationComplete: function onAnimationComplete() {
                  this.showTooltip(this.segments, true);
                },
                tooltipEvents: [],
                showTooltips: true
              },
              width: '350',
              height: '350'
            }),
            _react2.default.createElement(
              'p',
              { styleName: 'tsp-pie-chart-disclaimer' },
              this.props.roundToBillions(_config2.default.tspHoldingStats.ff_all_asset, false),
              'B in Thrift Savings Plan fossil fuel investments by industry. "Other" includes coal mining and conglomerates with carbon reserves and/or fossil fuel operations.'
            )
          )
        )
      );
    }
  }]);
  return TspPieChart;
}(_react.Component), _class6.propTypes = {
  roundToBillions: _react.PropTypes.func.isRequired
}, _temp2)) || _class5);
var TspCompanyCharts = (_dec5 = (0, _reactCssModules2.default)(_TspLanding2.default, { allowMultiple: true }), _dec5(_class7 = (_temp3 = _class8 = function (_Component5) {
  (0, _inherits3.default)(TspCompanyCharts, _Component5);

  function TspCompanyCharts(props) {
    (0, _classCallCheck3.default)(this, TspCompanyCharts);
    return (0, _possibleConstructorReturn3.default)(this, (TspCompanyCharts.__proto__ || (0, _getPrototypeOf2.default)(TspCompanyCharts)).call(this, props));
  }

  (0, _createClass3.default)(TspCompanyCharts, [{
    key: 'render',
    value: function render() {
      var _this7 = this;

      var icons = {
        'og': require('../../../static/images/tsp-og-bg.jpg'),
        'ut': require('../../../static/images/tsp-ut-bg.jpg')
      };
      return _react2.default.createElement(
        'div',
        null,
        [['og', 'oil & gas companies', 'oil & gas industry'], ['ut', 'fossil-fired utilities', 'fossil-fired utility']].map(function (c, i) {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { key: 'tsp-chart-' + i },
              ' ',
              _react2.default.createElement(
                _components.ContainerDivs,
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'tsp-company-chart-rel' },
                  ' ',
                  _react2.default.createElement(
                    'div',
                    { styleName: 'tsp-company-chart-bg' },
                    '  ',
                    _react2.default.createElement(
                      'div',
                      { styleName: 'tsp-company-chart-header' },
                      _react2.default.createElement(
                        'h2',
                        null,
                        _react2.default.createElement(
                          'strong',
                          { styleName: c[0] },
                          _this7.props.roundToBillions(_config2.default.tspHoldingStats[c[0]][0], false, true),
                          '\xA0'
                        ),
                        'in ',
                        c[1]
                      ),
                      _react2.default.createElement(
                        'h3',
                        null,
                        'Top 10 ',
                        c[2],
                        ' investments in Thrift Savings Plan funds'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'tsp-company-bar-wrap' },
                      _config2.default.tspHoldingStats[c[0]][2].map(function (e, i2) {
                        var w = e[1] / _config2.default.tspHoldingStats.og[2][0][1];
                        //
                        return _react2.default.createElement(
                          'div',
                          {
                            styleName: 'bar-chart-row',
                            key: 'bar-chart-row-' + i + '-' + i2
                          },
                          _react2.default.createElement(
                            _reactFlexboxGrid.Row,
                            null,
                            _react2.default.createElement(
                              _reactFlexboxGrid.Col,
                              { xs: 12, sm: 3 },
                              _react2.default.createElement(
                                'div',
                                { styleName: 'bar-chart-label' },
                                e[0]
                              )
                            ),
                            _react2.default.createElement(
                              _reactFlexboxGrid.Col,
                              { xs: 12, sm: 9 },
                              _react2.default.createElement(
                                'div',
                                { styleName: 'bar-chart-bar-wrap' },
                                _react2.default.createElement('div', {
                                  styleName: 'bar-chart-bar-' + c[0],
                                  style: {
                                    'width': w * 100 * 0.8 + '%'
                                  }
                                }),
                                _react2.default.createElement(
                                  'span',
                                  { styleName: 'bar-chart-figure' },
                                  _this7.props.roundToBillions(e[1], false, true)
                                )
                              )
                            )
                          )
                        );
                      })
                    ),
                    _react2.default.createElement('img', {
                      src: icons[c[0]],
                      alt: 'tmp',
                      styleName: 'tsp-company-chart-img'
                    })
                  )
                )
              )
            )
          );
        })
      );
    }
  }]);
  return TspCompanyCharts;
}(_react.Component), _class8.propTypes = {
  roundToBillions: _react.PropTypes.func.isRequired
}, _temp3)) || _class7);
var TspAssetManagers = (_dec6 = (0, _reactCssModules2.default)(_TspLanding2.default, { allowMultiple: true }), _dec6(_class9 = function (_Component6) {
  (0, _inherits3.default)(TspAssetManagers, _Component6);

  function TspAssetManagers() {
    (0, _classCallCheck3.default)(this, TspAssetManagers);
    return (0, _possibleConstructorReturn3.default)(this, (TspAssetManagers.__proto__ || (0, _getPrototypeOf2.default)(TspAssetManagers)).apply(this, arguments));
  }

  (0, _createClass3.default)(TspAssetManagers, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'am-banner-wrap' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'am-banner-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'am-banner-content-wrap' },
              _react2.default.createElement(
                'h2',
                { styleName: 'am-banner-h2' },
                'BlackRock and State Street are failing their responsibility of prudent and loyal stewardship'
              ),
              _react2.default.createElement(
                'p',
                null,
                'A significant proportion of TSP fund assets are managed by BlackRock and State Street, who routinely vote these shares according to their own investment policies.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Last year, BlackRock ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: 'https://www.reuters.com/business/finance/blackrock-continues-lowering-support-environmental-social-proposals-2023-08-23/',
                    title: 'BlackRock continues lowering support for environmental and social proposals'
                  },
                  'opposed 93%'
                ),
                ' of shareholder proposals related to climate change or social issues, up from 78% the year before, and 53% the year before that.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'State Street isn\'t much different. Research shows how both State Street and BlackRock support the status quo at climate-critical companies, voting in favor of boards of directors ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: 'https://www.majorityaction.us/climate-in-the-boardroom-2022',
                    title: 'Climate in the Boardroom: How Asset Manager Voting Shaped Corporate Climate Action in 2022'
                  },
                  'over 95% of the time.'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return TspAssetManagers;
}(_react.Component)) || _class9);
var TspFundItem = (_dec7 = (0, _reactCssModules2.default)(_TspLanding2.default, { allowMultiple: true }), _dec7(_class10 = (_temp4 = _class11 = function (_Component7) {
  (0, _inherits3.default)(TspFundItem, _Component7);

  function TspFundItem(props) {
    (0, _classCallCheck3.default)(this, TspFundItem);
    return (0, _possibleConstructorReturn3.default)(this, (TspFundItem.__proto__ || (0, _getPrototypeOf2.default)(TspFundItem)).call(this, props));
  }

  (0, _createClass3.default)(TspFundItem, [{
    key: 'getShareclassUrl',
    value: function getShareclassUrl(shareclass) {
      // const A = `${config.domain}`
      var B = _config2.default.routes.fund + '/';
      var C = _format2.default.sanitize(shareclass.fund_legal_name) + '/';
      var D = 'N/';
      var E = _config2.default.profilePath + '/';
      var F = shareclass.fund_id + '/';
      var G = shareclass.investment_vehicle_id + '/';

      return '' + B + C + D + E + F + G;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.fund) {
        return null;
      }
      var e = this.props.fund;
      if (!e.grade_fossil) {
        return _react2.default.createElement(
          'div',
          { styleName: 'tsp-fund-item-inactive' },
          e.fund_legal_name === 'L Income' ? e.fund_legal_name : e.fund_legal_name.slice(4, 10),
          ' ',
          _react2.default.createElement(
            'div',
            { styleName: 'tsp-inactive-asterisk' },
            '*'
          )
        );
      }
      return _react2.default.createElement(
        _components.Link,
        {
          to: this.getShareclassUrl(e),
          title: e.fund_legal_name
        },
        _react2.default.createElement(
          'div',
          { styleName: 'tsp-fund-item' },
          e.fund_legal_name.slice(4, 10),
          _react2.default.createElement(
            'div',
            { styleName: 'tsp-fund-item-grade' },
            _react2.default.createElement(
              'span',
              null,
              _format2.default.perc(e.c2f5coogutweight)
            ),
            _react2.default.createElement(_components.Grade, { grade: e.grade_fossil, blocksmall: true })
          )
        )
      );
    }
  }]);
  return TspFundItem;
}(_react.Component), _class11.propTypes = {
  fund: _react.PropTypes.object.isRequired
}, _temp4)) || _class10);
var TspRecommendations = (_dec8 = (0, _reactCssModules2.default)(_TspLanding2.default, { allowMultiple: true }), _dec8(_class12 = function (_Component8) {
  (0, _inherits3.default)(TspRecommendations, _Component8);

  function TspRecommendations() {
    (0, _classCallCheck3.default)(this, TspRecommendations);
    return (0, _possibleConstructorReturn3.default)(this, (TspRecommendations.__proto__ || (0, _getPrototypeOf2.default)(TspRecommendations)).apply(this, arguments));
  }

  (0, _createClass3.default)(TspRecommendations, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { styleName: 'anchor', id: 'recommendations' }),
        _react2.default.createElement(TspStarsBar, null),
        _react2.default.createElement(
          'div',
          { styleName: 'tsp-recs-wrap' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'tsp-recs-content' },
              _react2.default.createElement(
                'h2',
                null,
                'What can the TSP do?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The TSP is required to by law to track certain indices. But there are steps the plan could take to safeguard workers\' savings.'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      'AUDIT:'
                    ),
                    ' Perform and publish a rigorous audit of the TSP\'s exposure to climate-related financial risk.'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      'ENGAGE:'
                    ),
                    ' Engage TSP fund managers like BlackRock and State Street Global Advisors on climate risk-related proxy voting policies. Engage TSP index providers like S&P Global and MSCI to take climate risk into account in index management.'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      'EDUCATE:'
                    ),
                    ' Ensure employees are aware of the risk that climate change poses to their retirement savings.'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return TspRecommendations;
}(_react.Component)) || _class12);
var TspSolutionsTakeAction = (_dec9 = (0, _reactCssModules2.default)(_TspLanding2.default, { allowMultiple: true }), _dec9(_class13 = function (_Component9) {
  (0, _inherits3.default)(TspSolutionsTakeAction, _Component9);

  function TspSolutionsTakeAction() {
    (0, _classCallCheck3.default)(this, TspSolutionsTakeAction);
    return (0, _possibleConstructorReturn3.default)(this, (TspSolutionsTakeAction.__proto__ || (0, _getPrototypeOf2.default)(TspSolutionsTakeAction)).apply(this, arguments));
  }

  (0, _createClass3.default)(TspSolutionsTakeAction, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(TspStarsBar, null),
        _react2.default.createElement(
          'div',
          { styleName: 'solutions-take-action-wrap' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              [['The solutions', 'Learn about sustainable investing solutions and best\n                   practices\n                  ', 'https://investyourvalues.org/the-solutions'], ['Take action', 'Visit our employee resources center and learn how to\n                   invest in a sustainable future\n                  ', _config2.default.routes.tspToolkit], ['Self-directed option', 'Search thousands of funds to find fossil free\n                  alternatives through the TSP\'s self-directed option\n                  ', _config2.default.routes.list]].map(function (e, i) {
                var icon = require('../../../static/images/tsp-icon-circle-' + (i + 1) + '.png');
                return _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, sm: 4, key: 'tsp-col-' + i },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'tsp-col-' + i },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: e[2],
                        title: e[0]
                      },
                      _react2.default.createElement('img', { src: icon, alt: e[0] }),
                      _react2.default.createElement(
                        'h3',
                        { styleName: 'tsp-col-h3' },
                        e[0]
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'tsp-col-copy' },
                        e[1]
                      )
                    )
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return TspSolutionsTakeAction;
}(_react.Component)) || _class13);
var TspFAQs = (_dec10 = (0, _reactCssModules2.default)(_TspLanding2.default, { allowMultiple: true }), _dec10(_class14 = function (_Component10) {
  (0, _inherits3.default)(TspFAQs, _Component10);

  function TspFAQs(props) {
    (0, _classCallCheck3.default)(this, TspFAQs);

    var _this12 = (0, _possibleConstructorReturn3.default)(this, (TspFAQs.__proto__ || (0, _getPrototypeOf2.default)(TspFAQs)).call(this, props));

    _this12.state = {
      open: {},
      faqs: [[_react2.default.createElement(
        'span',
        null,
        'Can the TSP add new climate-safe fund options?'
      ), _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _components.Link,
          {
            to: 'https://www.law.cornell.edu/uscode/text/5/8438',
            title: '5 U.S. Code \xA7 8438 - Investment of Thrift Savings Fund'
          },
          'By law,'
        ),
        ' the TSP is constrained to offering a small set of funds that track "commonly recognized" indices with "reasonably complete" market representation, weighted by market capitalization. Absent the introduction of a climate-safe index that meets these standards, TSP is effectively precluded from adding new climate-safe sustainable fund options without action from Congress. Some members of Congress have introduced legislation that would allow the TSP to add climate-safe options. Because the TSP faces such legal restrictions, it\u2019s all the more important that the plan take action to audit, engage, and educate on climate risk.'
      )], [_react2.default.createElement(
        'span',
        null,
        'Does the TSP have a self-directed option with climate-safe funds?'
      ), _react2.default.createElement(
        'span',
        null,
        'In 2022, the TSP added a ',
        _react2.default.createElement(
          _components.Link,
          {
            to: 'https://www.tsp.gov/mutual-fund-window/',
            title: 'Mutual Fund Window | Thrift Savings Plan'
          },
          '"mutual fund window",'
        ),
        ' also known as a self-directed option. This gives plan participants access to a wider range of fund options, including climate-safe sustainable funds. But the window comes with higher fees, limits on who can use it, and limits on how much can be invested. More broadly, plans that offer self-directed options usually see only between 1 and 2% of plan assets invested through them. Self-directed retirement options shift the practical responsibility for risk management from the plan to the participant. At best, it\u2019s a band-aid that doesn\u2019t address the climate risk facing the vast majority of the plan\'s assets.'
      )], [_react2.default.createElement(
        'span',
        null,
        'Can the TSP vote in favor of climate-related shareholder proposals?'
      ), _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _components.Link,
          {
            to: 'https://www.law.cornell.edu/uscode/text/5/8438',
            title: '5 U.S. Code \xA7 8438 - Investment of Thrift Savings Fund'
          },
          'By law,'
        ),
        ' the TSP is not allowed to directly vote on shareholder proposals or for boards of directors at the companies it invests in. But a significant proportion of its fund assets are managed by BlackRock and State Street, who routinely vote the shares associated with TSP funds according to their own investment policies. There\u2019s nothing stopping the Federal Retirement Thrift Investment Board (FRTIB), the officials responsible for managing the TSP, from engaging these asset managers on their proxy voting guidelines. In fact, FRTIB\u2019s fiduciary duty compels it to review these guidelines to ensure they are in participants\u2019 best interests. Last year, ',
        _react2.default.createElement(
          _components.Link,
          {
            to: 'https://www.bloomberg.com/news/articles/2023-08-23/blackrock-backs-fewer-climate-social-shareholder-proposals#xj4y7vzkg',
            title: 'BlackRock Backs Fewer Climate, Social Shareholder Proposals'
          },
          'BlackRock opposed 93%'
        ),
        ' of shareholder proposals related to climate change or social issues. State Street isn\'t much different. The FRTIB should engage these managers to ensure that TSP shares are voted in a way that minimizes climate-related financial risk.'
      )], [_react2.default.createElement(
        'span',
        null,
        'What role do BlackRock and State Street play?'
      ), _react2.default.createElement(
        'span',
        null,
        'BlackRock and State Street manage the $725 billion invested in the TSP, following the guidelines set by the law and the Federal Retirement Thrift Investment Board. As asset managers, they have a responsibility to act as prudent and loyal stewards of their clients\u2019 assets. But BlackRock and State Street ',
        _react2.default.createElement(
          _components.Link,
          {
            to: 'https://www.majorityaction.us/climate-in-the-boardroom-2022',
            title: 'Climate in the Boardroom: How Asset Manager Voting Shaped Corporate Climate Action in 2022'
          },
          'often fail in this responsibility,'
        ),
        ' opposing the vast majority of shareholder proposals related to climate change, and refusing to hold boards of directors to account for inaction on addressing climate risk. These asset managers should update their proxy voting policies to reflect an intention that proxy voting be aligned to the goal of limiting global temperature rise to 1.5\xB0C, and the expectation that portfolio companies will take action on emissions consistent with a 1.5\xB0C pathway, including target setting and capital allocation.'
      )], [_react2.default.createElement(
        'span',
        null,
        'What steps have other retirement savings systems taken to protect from climate risk?'
      ), _react2.default.createElement(
        'span',
        null,
        'Some ',
        _react2.default.createElement(
          _components.Link,
          {
            to: 'https://www.bloomberg.com/news/features/2022-10-20/how-to-purge-fossil-fuel-investments-from-your-401-k-or-ira#xj4y7vzkg',
            title: 'What\u2019s in Your 401(k)? Polluters Driving Climate Change'
          },
          '1,500 institutions'
        ),
        ' representing more than $40 trillion in assets have committed to reducing exposure to investments in high-carbon industries. This includes retirement savings systems: The University of California (UC) removed all companies that own fossil fuel reserves from the ',
        _react2.default.createElement(
          _components.Link,
          {
            to: 'https://myucretirement.com/Resource/2312',
            title: 'Changes to the UC Retirement Savings Program (RSP) fund offerings'
          },
          'UC Retirement Savings Program'
        ),
        ' on the basis that \u201Cthe fossil fuel industry faces considerable long term financial risk\u201D and that removing such companies \u201Cwill have a positive financial and risk-reducing impact on fund performance in the long run.\u201D But many 401(k)s are still directing employee savings to climate-risky investments by default. Retirement savers first need access to sustainable fund options, and ultimately, sustainability should become the standard. (Our  ',
        _react2.default.createElement(
          _components.Link,
          {
            to: 'https://investyourvalues.org/',
            title: 'Retirement Plan Sustainability Scorecard | Invest Your Values'
          },
          '401(k) Scorecard'
        ),
        ' tracks close to 50 employer-offered retirement plans.)'
      )], [_react2.default.createElement(
        'span',
        null,
        'What is climate-related investment risk?'
      ), _react2.default.createElement(
        'span',
        null,
        'Climate change is accelerating, resulting in a growing number of climate-related natural disasters, and the economic impacts are becoming increasingly evident. Climate-related investment risk is the risk that the economic impacts of climate change will cause your investments to suffer losses. ',
        _react2.default.createElement(
          'i',
          null,
          'Physical climate change risk'
        ),
        ' is the threat to asset prices posed by emissions-fueled disasters such as flooding, wildfires, or hurricanes. Companies also face ',
        _react2.default.createElement(
          'i',
          null,
          'transition risk'
        ),
        ' as we shift towards a clean energy economy. Achieving decarbonization of the world economy requires a transition away from carbon-based energy, which will necessarily alter some companies\u2019 businesses. High-carbon industries face some of the most significant physical and transition risks, and addressing climate-related investment risk usually involves carefully scrutinizing investments in these sectors.'
      )], [_react2.default.createElement(
        'span',
        null,
        'Where did you get this data?'
      ), _react2.default.createElement(
        'span',
        null,
        'This analysis applies our Fossil Free Funds rating methodology to the TSP fund options. The TSP does not publish fund holdings, but each of the individual equity funds tracks a commonly-used index, tracked by many index funds. For the individual funds, we used a matching index fund as a stand-in. The L funds are made up of varying proportions of the individual equity and fixed-income funds (C, S, I, F, and G funds). For these target date funds, we used allocation data from the ',
        _react2.default.createElement(
          _components.Link,
          {
            to: 'https://www.tsp.gov/funds-lifecycle/',
            title: 'Lifecycle funds | Thrift Savings Plan'
          },
          'TSP.gov website'
        ),
        ' to model each portfolio using the individual fund analyses. We used assets-under-management to calculate figures like overall fossil fuel investments. See our full ',
        _react2.default.createElement(
          _components.Link,
          {
            to: _config2.default.routes.howitworks,
            title: 'How it works | Fossil Free Funds'
          },
          'Fossil Free Funds methodology here.'
        ),
        ' A detailed analysis of the TSP funds ',
        _react2.default.createElement(
          _components.Link,
          {
            to: 'https://investyourvalues.org/retirement-plans/thrift-savings-plan',
            title: 'Thrift Savings Plan | 401(k) Scorecard | Invest Your Values'
          },
          'across multiple environmental and social issues is here.'
        )
      )]]
    };
    return _this12;
  }

  (0, _createClass3.default)(TspFAQs, [{
    key: 'render',
    value: function render() {
      var _this13 = this;

      return _react2.default.createElement(
        'div',
        { styleName: 'tsp-faq-wrap' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12, md: 5, lg: 5 },
              _react2.default.createElement(
                'h2',
                { styleName: 'faq-h2' },
                'Frequently asked questions'
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12, md: 7, lg: 7 },
              this.state.faqs.map(function (e, i) {
                return _react2.default.createElement(
                  'div',
                  { styleName: 'tsp-faq-item', key: 'tsp-faq-item' + i },
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        var newOpenState = _this13.state.open;
                        newOpenState[i] = !newOpenState[i] || newOpenState[i] === null;
                        _this13.setState({ open: newOpenState });
                      },
                      styleName: 'tsp-faq-q'
                    },
                    _react2.default.createElement(
                      'h3',
                      null,
                      e[0]
                    ),
                    _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: _this13.state.open[i] ? 'fa-angle-up' : 'fa-angle-down' })
                  ),
                  _react2.default.createElement(
                    _reactSlidedown.SlideDown,
                    null,
                    _this13.state.open[i] ? _react2.default.createElement(
                      'div',
                      { styleName: 'tsp-faq-a' },
                      _react2.default.createElement(
                        'p',
                        null,
                        e[1]
                      )
                    ) : null
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return TspFAQs;
}(_react.Component)) || _class14);
var TspLanding = (_dec11 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.tspShareClass.result,
    searching: state.tspShareClass.loading,
    searched: state.tspShareClass.loaded,
    error: state.tspShareClass.error
  };
}, searchActions), _dec12 = (0, _reactCssModules2.default)(_TspLanding2.default, { allowMultiple: true }), _dec11(_class15 = _dec12(_class15 = (_temp5 = _class16 = function (_Component11) {
  (0, _inherits3.default)(TspLanding, _Component11);

  function TspLanding(props) {
    (0, _classCallCheck3.default)(this, TspLanding);

    var _this14 = (0, _possibleConstructorReturn3.default)(this, (TspLanding.__proto__ || (0, _getPrototypeOf2.default)(TspLanding)).call(this, props));

    _this14.state = {
      tspByType: _this14.defaultTspByType(),
      chartFilter: 'og'
    };
    return _this14;
  }

  (0, _createClass3.default)(TspLanding, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // if (typeof window !== 'undefined') {
      //   window.scrollTo(0,0)
      // }
      this.props.tspShareClasses();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      // split into L, Ind -> (E, B)
      var tspByType = this.defaultTspByType();

      props.result.forEach(function (r) {
        if (r.fund_legal_name.slice(0, 5) === 'TSP L') {
          tspByType.L.push(r);
        } else {
          tspByType.E.push(r);
        }
      });

      tspByType.L = tspByType.L.sort(function (a, b) {
        return b.fund_legal_name.localeCompare(a.fund_legal_name);
      });
      tspByType.E = tspByType.E.sort(function (a, b) {
        return a.net_assets - b.net_assets;
      });

      tspByType.L.push({ 'fund_legal_name': 'TSP L 2025' });
      tspByType.L.push({ 'fund_legal_name': 'L Income' });

      this.setState({
        tspByType: tspByType
      });
    }
  }, {
    key: 'defaultTspByType',
    value: function defaultTspByType() {
      return {
        'L': [],
        'E': [],
        'B': []
      };
    }
  }, {
    key: 'roundToBillions',
    value: function roundToBillions(x) {
      var full = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var letter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var ONE_BILLION = 1000000000;
      var ONE_MILLION = 1000000;
      var mult = full ? ONE_BILLION : 1;
      if (x > ONE_BILLION) {
        return '$' + ((x / ONE_BILLION).toFixed(1) * mult).toLocaleString() + (letter ? 'B' : '');
      } else {
        return '$' + ((x / ONE_MILLION).toFixed(0) * mult).toLocaleString() + (letter ? 'M' : '');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Thrift Savings Plan';
      var desc = 'The Federal government\'s retirement plan has billions invested in fossil fuels putting the climate at risk.';
      var url = _config2.default.domain + _config2.default.routes.tspLanding;

      var socialShareUrl = _config2.default.domain + _tspSocialShare2.default.replace(/.*dist/, '/dist');

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(title, desc, url),
        _react2.default.createElement(_reactHelmet2.default, { meta: [{ property: 'og:image', content: socialShareUrl }, { property: 'twitter:image', content: socialShareUrl }] }),
        _react2.default.createElement(TspLede, { roundToBillions: this.roundToBillions }),
        _react2.default.createElement(TspPieChart, { roundToBillions: this.roundToBillions }),
        _react2.default.createElement(TspBanner, null),
        _react2.default.createElement(TspCompanyCharts, { roundToBillions: this.roundToBillions }),
        _react2.default.createElement(TspStarsBar, null),
        _react2.default.createElement(TspAssetManagers, null),
        _react2.default.createElement(TspStarsBar, null),
        _react2.default.createElement(
          'div',
          { styleName: 'tsp-nav-wrap' },
          this.props.searching || !this.props.result || this.props.result.length === 0 ? _react2.default.createElement(
            'div',
            { styleName: 'tsp-nav-loader-wrap' },
            _react2.default.createElement(_reactLoader2.default, {
              options: { scale: 0.70, top: '2rem' },
              loaded: false
            })
          ) : _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h2',
              { styleName: 'tsp-nav-h2' },
              'Select a Thrift Savings Plan (TSP) fund below to see its fossil fuel investments:'
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 6 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'tsp-nav-col' },
                  _react2.default.createElement(
                    'h3',
                    { styleName: 'tsp-nav-col-label' },
                    'LIFECYCLE FUNDS'
                  ),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'tsp-nav-col-section-label' },
                    'Target date funds'
                  ),
                  this.state.tspByType.L.map(function (e, i) {
                    return _react2.default.createElement(TspFundItem, { key: 'l-funds-' + i, fund: e });
                  })
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 6 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'tsp-nav-col' },
                  _react2.default.createElement(_components.XsBr, null),
                  _react2.default.createElement(_components.XsBr, null),
                  _react2.default.createElement(
                    'h3',
                    { styleName: 'tsp-nav-col-label' },
                    'INDIVIDUAL FUNDS'
                  ),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'tsp-nav-col-section-label' },
                    'Equity funds'
                  ),
                  this.state.tspByType.E.map(function (e, i) {
                    return _react2.default.createElement(TspFundItem, { key: 'e-funds-' + i, fund: e });
                  }),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'tsp-nav-col-section-label' },
                    'Fixed income/stable value funds'
                  ),
                  [{ 'fund_legal_name': 'TSP G Fund' }, { 'fund_legal_name': 'TSP F Fund' }].map(function (e, i) {
                    return _react2.default.createElement(TspFundItem, { key: 'b-funds-' + i, fund: e });
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'tsp-nav-disclaimer' },
              _react2.default.createElement(
                'div',
                { styleName: 'tsp-nav-disclaimer-icon' },
                _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-info-circle' })
              ),
              _react2.default.createElement(
                'p',
                null,
                'The TSP offers five core funds: three equity funds (the C, S, and I funds), and two bond funds (the F and G funds). It also offers a sequence of 10 target date funds, called the L funds, which themselves invest in the core individual funds. For each of these funds, we\'ve measured the fund exposure to fossil fuel investments. We show the percentage of fund assets in fossil fuel stocks, and we show a fossil fuel letter grade based on that exposure. Click any fund to see more detailed results.'
              )
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'tsp-bond-disclaimer' },
              '* Bond fund results are currently unavailable. Check back soon.'
            )
          )
        ),
        _react2.default.createElement(TspRecommendations, null),
        _react2.default.createElement(TspSolutionsTakeAction, null),
        _react2.default.createElement(TspFAQs, null)
      );
    }
  }]);
  return TspLanding;
}(_react.Component), _class16.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array
}, _class16.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp5)) || _class15) || _class15);
exports.default = TspLanding;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TspLanding/TspLanding.js
// module id = 1422
// module chunks = 0